// Add parallax effect to images
export const parallaxImages = (wrapper) => {
	wrapper.forEach((wrapper) => {
		const images = wrapper.querySelectorAll("img");
		if (images.length > 0) {
			images.forEach((img) => {
				scrollSmoother.effects(img, { speed: "auto" });
			});
		}
	});
};
